"use strict";

var _agentsData = _interopRequireDefault(require("../../config/agentsData.json"));
var _helpers = require("./helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
describe('AgentDeveloperUtils', function () {
  var agentDeveloperUtils;
  beforeEach(function () {
    agentDeveloperUtils = new _helpers.AgentDeveloperUtils();
    agentDeveloperUtils.getAgentDeveloperData();
  });
  it('should initialize with default agent data', function () {
    expect(agentDeveloperUtils.agentData).toEqual(_agentsData.default[0]);
  });
  it('should update agentsDeveloperData', function () {
    expect(agentDeveloperUtils.agentsDeveloperData).toEqual(_agentsData.default);
  });
  it('should update agentData based on typeOfAgent in localStorage Post il', function () {
    localStorage.setItem('typeOfAgent', 'Post_IL');
    agentDeveloperUtils.getAgentDeveloperData();
    expect(agentDeveloperUtils.agentData.Agent_Developer_Name_c).toEqual('Post_IL');
    localStorage.removeItem('typeOfAgent');
  });
  it('should update agentData based on typeOfAgent in localStorage wobi', function () {
    localStorage.setItem('typeOfAgent', 'Wobi');
    agentDeveloperUtils.getAgentDeveloperData();
    expect(agentDeveloperUtils.agentData.Agent_Developer_Name_c).toEqual('Wobi');
    localStorage.removeItem('typeOfAgent');
  });
  it('should update agentData based on hostname for auto service type', function () {
    var hostname = 'localhost.autoinsurance.post.il';
    window.location.hostname = hostname;
    agentDeveloperUtils.getAgentDeveloperData();
    expect(agentDeveloperUtils.agentData.websites.auto.baseUrl).toContain(hostname);
  });
  it('should update agentData based on hostname for travel service type', function () {
    var hostname = 'localhosttravelinsurance.post.il';
    window.location.hostname = hostname;
    agentDeveloperUtils.getAgentDeveloperData();
    expect(agentDeveloperUtils.agentData.websites.travel.baseUrl).toContain(hostname);
  });
  it('should update agentData based on hostname for home service type', function () {
    var hostname = 'localhosthomeinsurance.post.il';
    window.location.hostname = hostname;
    agentDeveloperUtils.getAgentDeveloperData();
    expect(agentDeveloperUtils.agentData.websites.home.baseUrl).toContain(hostname);
  });
  it('get gtmId based on serviceType', function () {
    var gtmId = agentDeveloperUtils.getGtmId();
    expect(gtmId).toEqual(agentDeveloperUtils.agentData.websites[agentDeveloperUtils.serviceType].TAG_MANAGER_ID);
  });
  it('should set window title based on agentData', function () {
    var serviceType = 'home';
    agentDeveloperUtils.getAgentDeveloperData();
    expect(window.document.title).toEqual(agentDeveloperUtils.agentData.websites[serviceType].windowTitle);
  });
  it('should return primary color based on number', function () {
    var number = 0;
    var primaryColor = agentDeveloperUtils.getPrimaryColor(number);
    expect(primaryColor).toEqual(agentDeveloperUtils.agentData.colors.primaryColor[number]);
  });
  it('should return secondary color based on number', function () {
    var number = 300;
    var secondaryColor = agentDeveloperUtils.getSecondaryColor(number);
    expect(secondaryColor).toEqual(agentDeveloperUtils.agentData.colors.secondaryColor[number]);
  });
});